// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AbSUY","spinnerContainer":"styles_spinnerContainer__MQgeW","hide":"styles_hide__FGJH5","cancelUpload":"styles_cancelUpload__SI5AO"};